import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f5c7829"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "overlay"
}
const _hoisted_2 = { style: {"height":"90vh","background-color":"white"} }
const _hoisted_3 = { style: {"height":"0.5vh"} }
const _hoisted_4 = { class: "p-mt-2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  style: {"font-size":"20px"},
  class: "pi pi-globe"
}, null, -1))
const _hoisted_6 = { class: "p-mx-1" }
const _hoisted_7 = { class: "p-mx-1" }
const _hoisted_8 = { class: "p-grid p-m-0" }
const _hoisted_9 = { class: "p-col-9" }
const _hoisted_10 = {
  class: "pos-table",
  style: {"height":"72.7vh"}
}
const _hoisted_11 = { class: "table table-stiped table-bordered p-m-0" }
const _hoisted_12 = { class: "pos-heading" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"18rem"} }, "Item", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Batch", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Unit", -1))
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { style: {"width":"5rem"} }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Expiry", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Disc (%)", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "REMOVE", -1))
const _hoisted_21 = { class: "table-row" }
const _hoisted_22 = { class: "p-pt-2" }
const _hoisted_23 = { class: "p-pt-2" }
const _hoisted_24 = { class: "p-inputgroup" }
const _hoisted_25 = { class: "p-pt-2" }
const _hoisted_26 = { class: "p-pt-2" }
const _hoisted_27 = { class: "p-pt-2" }
const _hoisted_28 = { class: "p-pt-2" }
const _hoisted_29 = { class: "p-text-center" }
const _hoisted_30 = { class: "item-detail-row" }
const _hoisted_31 = ["colspan"]
const _hoisted_32 = { class: "p-mr-1" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" GENERIC: ")
const _hoisted_34 = { style: {"color":"#fff","background-color":"#c00"} }
const _hoisted_35 = { class: "p-mx-1" }
const _hoisted_36 = {
  key: 0,
  class: "p-mx-1"
}
const _hoisted_37 = {
  key: 1,
  class: "p-mx-1"
}
const _hoisted_38 = {
  key: 2,
  class: "p-mx-1"
}
const _hoisted_39 = { class: "p-mx-1" }
const _hoisted_40 = {
  class: "p-col-3",
  style: {"border-left":"1px solid #eee"}
}
const _hoisted_41 = { class: "p-fluid" }
const _hoisted_42 = { class: "p-field" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "customername" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"12px","color":"#11467e"},
    class: "pi pi-file"
  }),
  /*#__PURE__*/_createTextVNode(" Customer Name ")
], -1))
const _hoisted_44 = { key: 1 }
const _hoisted_45 = /*#__PURE__*/_createTextVNode(" NAME : ")
const _hoisted_46 = { class: "pull-right" }
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" Email : ")
const _hoisted_48 = { class: "pull-right" }
const _hoisted_49 = /*#__PURE__*/_createTextVNode(" Contact : ")
const _hoisted_50 = { class: "pull-right" }
const _hoisted_51 = /*#__PURE__*/_createTextVNode(" Account Type : ")
const _hoisted_52 = { class: "pull-right" }
const _hoisted_53 = { key: 2 }
const _hoisted_54 = { class: "p-error" }
const _hoisted_55 = {
  key: 3,
  class: "p-error"
}
const _hoisted_56 = { class: "p-field" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "contactnumber" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"12px","color":"#11467e"},
    class: "pi pi-file"
  }),
  /*#__PURE__*/_createTextVNode(" Customer Contact Number ")
], -1))
const _hoisted_58 = { key: 1 }
const _hoisted_59 = /*#__PURE__*/_createTextVNode(" NAME : ")
const _hoisted_60 = { class: "pull-right" }
const _hoisted_61 = /*#__PURE__*/_createTextVNode(" Email : ")
const _hoisted_62 = { class: "pull-right" }
const _hoisted_63 = /*#__PURE__*/_createTextVNode(" Contact : ")
const _hoisted_64 = { class: "pull-right" }
const _hoisted_65 = /*#__PURE__*/_createTextVNode(" Account Type : ")
const _hoisted_66 = { class: "pull-right" }
const _hoisted_67 = { key: 2 }
const _hoisted_68 = { class: "p-error" }
const _hoisted_69 = {
  key: 3,
  class: "p-error"
}
const _hoisted_70 = {
  key: 0,
  class: "p-fluid"
}
const _hoisted_71 = { class: "p-field" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "description" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"12px","color":"#11467e"},
    class: "pi pi-file"
  }),
  /*#__PURE__*/_createTextVNode(" Choose Transfer Store ")
], -1))
const _hoisted_73 = { key: 0 }
const _hoisted_74 = { class: "p-error" }
const _hoisted_75 = {
  key: 1,
  class: "p-error"
}
const _hoisted_76 = {
  key: 1,
  class: "p-fluid"
}
const _hoisted_77 = { class: "p-field" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "description" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"12px","color":"#11467e"},
    class: "pi pi-file"
  }),
  /*#__PURE__*/_createTextVNode(" Patient Description ")
], -1))
const _hoisted_79 = {
  key: 2,
  class: "p-fluid"
}
const _hoisted_80 = { class: "p-field" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "description" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"12px","color":"#11467e"},
    class: "pi pi-file"
  }),
  /*#__PURE__*/_createTextVNode(" Doctor Description ")
], -1))
const _hoisted_82 = { class: "p-fluid" }
const _hoisted_83 = { class: "p-field" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "description" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"12px","color":"#11467e"},
    class: "pi pi-file"
  }),
  /*#__PURE__*/_createTextVNode(" Receipt Description ")
], -1))
const _hoisted_85 = { class: "p-fluid" }
const _hoisted_86 = { class: "p-field" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "description" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"12px","color":"#11467e"},
    class: "pi pi-file"
  }),
  /*#__PURE__*/_createTextVNode(" Remark ")
], -1))
const _hoisted_88 = { class: "p-fluid" }
const _hoisted_89 = { class: "p-field" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "description" }, "Taxes Includes", -1))
const _hoisted_91 = { class: "p-inputgroup" }
const _hoisted_92 = {
  key: 0,
  class: "p-inputgroup-addon"
}
const _hoisted_93 = { class: "p-mx-2" }
const _hoisted_94 = {
  key: 1,
  class: "p-inputgroup-addon"
}
const _hoisted_95 = { class: "p-mx-2" }
const _hoisted_96 = {
  key: 2,
  class: "p-inputgroup-addon"
}
const _hoisted_97 = { class: "p-mx-2" }
const _hoisted_98 = { class: "p-fluid flex-container" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "description" }, "Invoice Discount", -1))
const _hoisted_100 = { class: "flex-row" }
const _hoisted_101 = ["value"]
const _hoisted_102 = { class: "flex-span" }
const _hoisted_103 = {
  style: {"height":"10vh"},
  class: "p-grid p-m-0 p-p-0"
}
const _hoisted_104 = { class: "set-bottom-amt p-col" }
const _hoisted_105 = /*#__PURE__*/_createTextVNode("Product QTY ")
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_107 = { class: "set-bottom-amt p-col" }
const _hoisted_108 = /*#__PURE__*/_createTextVNode("Total Gross ")
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_110 = { class: "set-bottom-amt p-col" }
const _hoisted_111 = /*#__PURE__*/_createTextVNode("Total Disc ")
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_113 = {
  key: 0,
  class: "set-bottom-amt p-col"
}
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_115 = {
  key: 1,
  class: "set-bottom-amt p-col"
}
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_117 = {
  key: 2,
  class: "set-bottom-amt p-col"
}
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_119 = { class: "set-bottom-amt p-col" }
const _hoisted_120 = /*#__PURE__*/_createTextVNode("Net Total ")
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_122 = ["hidden"]
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_124 = { class: "confirmation-content" }
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-search p-mr-3",
  style: {"font-size":"2rem"}
}, null, -1))
const _hoisted_126 = {
  key: 0,
  class: "p-fluid"
}
const _hoisted_127 = { class: "p-field" }
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "search_receipt" }, " Enter Receipt No ", -1))
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "confirmation-content" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "pi pi-exclamation-triangle p-mr-3",
    style: {"font-size":"2rem"}
  }),
  /*#__PURE__*/_createElementVNode("span", null, "Are you sure to delete the profile name? Any changes you make to profile name won't be effective in actual profile")
], -1))
const _hoisted_130 = { class: "confirmation-content" }
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-exclamation-triangle p-mr-3",
  style: {"font-size":"2rem"}
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Chips = _resolveComponent("Chips")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_fullscreen = _resolveComponent("fullscreen")!
  const _component_PaymentScreen = _resolveComponent("PaymentScreen")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.progressBar)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    _createVNode(_component_fullscreen, {
      fullscreen: _ctx.screenState.fullscreen,
      "onUpdate:fullscreen": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.screenState.fullscreen) = $event)),
      teleport: _ctx.screenState.teleport,
      "page-only": _ctx.screenState.pageOnly
    }, {
      default: _withCtx(() => [
        _createElementVNode("section", null, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (_ctx.progressBar)
                ? (_openBlock(), _createBlock(_component_ProgressBar, {
                    key: 0,
                    mode: "indeterminate",
                    style: {"height":"0.2em"}
                  }))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_Toolbar, { style: {"height":"7.5vh"} }, {
              start: _withCtx(() => [
                _createElementVNode("h5", _hoisted_4, [
                  _createElementVNode("b", null, [
                    _hoisted_5,
                    _createTextVNode(" " + _toDisplayString(_ctx.storeName), 1)
                  ])
                ])
              ]),
              end: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_Button, {
                    icon: "pi pi-search",
                    label: "Search Refund",
                    class: "p-button-danger",
                    id: "search-refund",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (this.refundReceiptDialog = true))
                  })
                ]),
                _createElementVNode("div", _hoisted_7, [
                  (!_ctx.screenState.fullscreen)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        icon: "pi pi-window-maximize",
                        class: "p-button-warning",
                        onClick: _ctx.toggleScreen
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  (_ctx.screenState.fullscreen)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 1,
                        icon: "pi pi-window-minimize",
                        class: "p-button-warning",
                        onClick: _ctx.toggleScreen
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("table", _hoisted_11, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", _hoisted_12, [
                        _hoisted_13,
                        _hoisted_14,
                        _hoisted_15,
                        (_ctx.item.type == 'TRN')
                          ? (_openBlock(), _createElementBlock("th", _hoisted_16, "Gift Unit"))
                          : _createCommentVNode("", true),
                        _createElementVNode("th", _hoisted_17, "Price (" + _toDisplayString(_ctx.currency) + ")", 1),
                        _hoisted_18,
                        _hoisted_19,
                        _createElementVNode("th", null, "Subtotal (" + _toDisplayString(_ctx.currency) + ")", 1),
                        _hoisted_20
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.savedItemList.slice().reverse(), (savedItem) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: savedItem.id
                        }, [
                          _createElementVNode("tr", _hoisted_21, [
                            _createElementVNode("td", _hoisted_22, [
                              _createElementVNode("small", null, _toDisplayString(_ctx.limitString(savedItem.productName)), 1)
                            ]),
                            _createElementVNode("td", _hoisted_23, [
                              _createElementVNode("small", null, _toDisplayString(savedItem.batchNo), 1)
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", _hoisted_24, [
                                _createVNode(_component_Button, {
                                  icon: "pi pi-plus",
                                  class: "p-button-success p-p-0",
                                  onClick: ($event: any) => (_ctx.adjustQty('add', savedItem))
                                }, null, 8, ["onClick"]),
                                _createVNode(_component_InputText, {
                                  style: {"width":"2rem","height":"35px"},
                                  modelValue: savedItem.unit,
                                  "onUpdate:modelValue": ($event: any) => ((savedItem.unit) = $event),
                                  modelModifiers: { number: true },
                                  id: 'item-unit-' + savedItem.rowID,
                                  onKeydown: [
                                    _withKeys(_withModifiers(($event: any) => (_ctx.adjustQty('add', savedItem)), ["prevent"]), ["i"]),
                                    _withKeys(_withModifiers(($event: any) => (_ctx.adjustQty('minus', savedItem)), ["prevent"]), ["d"]),
                                    _withKeys(_withModifiers(($event: any) => (
                              _ctx.focusNext(
                                'item-unit-' + _ctx.getNextActiveItem(savedItem.rowID),
                                $event,
                                null
                              )
                            ), ["prevent"]), ["up"]),
                                    _withKeys(_withModifiers(($event: any) => (
                              _ctx.focusNext(
                                'item-unit-' + _ctx.getPreviousActiveItem(savedItem.rowID),
                                $event,
                                null
                              )
                            ), ["prevent"]), ["down"]),
                                    _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (
                              _ctx.focusNext('remarkField', $event, null)
                            ), ["prevent"]), ["right"])),
                                    _withKeys(_withModifiers(($event: any) => (_ctx.clearListItem(savedItem)), ["prevent"]), ["-"])
                                  ],
                                  class: _normalizeClass(["p-p-0 p-m-0", {'is-invalid': savedItem.unit == 0 || savedItem.unit > savedItem.refundUnit}]),
                                  onInput: ($event: any) => (_ctx.validateUnit(savedItem, $event))
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "id", "onKeydown", "onInput", "class"]),
                                _createVNode(_component_Button, {
                                  icon: "pi pi-minus",
                                  class: "p-button-warning p-p-0",
                                  onClick: ($event: any) => (_ctx.adjustQty('minus', savedItem))
                                }, null, 8, ["onClick"])
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_25, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(savedItem.sellingPrice)), 1),
                            _createElementVNode("td", _hoisted_26, _toDisplayString(_ctx.formatExpiryDate(savedItem.expiryDate)), 1),
                            _createElementVNode("td", _hoisted_27, _toDisplayString(_ctx.fixDigits(savedItem.itemDisc)), 1),
                            _createElementVNode("td", _hoisted_28, _toDisplayString(_ctx.getTheSubtotal(savedItem)), 1),
                            _createElementVNode("td", _hoisted_29, [
                              _createVNode(_component_Button, {
                                icon: "pi pi-minus",
                                class: "p-button-danger p-p-1",
                                onClick: ($event: any) => (_ctx.clearListItem(savedItem))
                              }, null, 8, ["onClick"])
                            ])
                          ]),
                          _createElementVNode("tr", _hoisted_30, [
                            _createElementVNode("td", {
                              colspan: _ctx.item.type == 'TRN' ? 9 : 8
                            }, [
                              _createElementVNode("span", _hoisted_32, [
                                _hoisted_33,
                                _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.limitString(savedItem.generic)), 1)
                              ]),
                              _createElementVNode("span", _hoisted_35, " BATCH NO : " + _toDisplayString(savedItem.batchNo), 1),
                              (_ctx.taxNames[0] && _ctx.taxNames[0].show)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(_ctx.taxNames[0]?.taxName) + " : " + _toDisplayString(_ctx.fixDigits(savedItem.tax1)) + "% ", 1))
                                : _createCommentVNode("", true),
                              (_ctx.taxNames[1] && _ctx.taxNames[1].show)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(_ctx.taxNames[1]?.taxName) + " : " + _toDisplayString(_ctx.fixDigits(savedItem.tax2)) + "% ", 1))
                                : _createCommentVNode("", true),
                              (_ctx.taxNames[2] && _ctx.taxNames[2].show)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(_ctx.taxNames[2]?.taxName) + " : " + _toDisplayString(_ctx.fixDigits(savedItem.tax3)) + "% ", 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("span", _hoisted_39, " TOTAL REFUND UNITS : " + _toDisplayString(_ctx.fixDigits(savedItem.totalUnit, 0)), 1)
                            ], 8, _hoisted_31)
                          ])
                        ], 64))
                      }), 128))
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    _hoisted_43,
                    (!_ctx.delayedChippedTel)
                      ? (_openBlock(), _createBlock(_component_Chips, {
                          key: 0,
                          modelValue: _ctx.state.chippedProfile,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.chippedProfile) = $event)),
                          readonly: true,
                          onRemove: _cache[3] || (_cache[3] = ($event: any) => (_ctx.removeProfile($event))),
                          class: "p-chips-input-token"
                        }, null, 8, ["modelValue"]))
                      : _createCommentVNode("", true),
                    (_ctx.delayedChippedTel)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                          _createVNode(_component_AutoComplete, {
                            delay: 200,
                            minLength: 3,
                            onItemSelect: _cache[4] || (_cache[4] = ($event: any) => (_ctx.saveProfile($event))),
                            scrollHeight: "500px",
                            modelValue: _ctx.v$.selectedProfile.$model,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.v$.selectedProfile.$model) = $event)),
                            suggestions: _ctx.profilerList,
                            placeholder: "Search Profile",
                            onComplete: _cache[6] || (_cache[6] = ($event: any) => (_ctx.searchProfiler($event))),
                            dropdown: false,
                            autoFocus: "",
                            disabled: ""
                          }, {
                            item: _withCtx((slotProps) => [
                              _createElementVNode("div", null, [
                                _hoisted_45,
                                _createElementVNode("b", _hoisted_46, _toDisplayString(slotProps.item.account_title.toUpperCase()), 1)
                              ]),
                              _createElementVNode("div", null, [
                                _hoisted_47,
                                _createElementVNode("span", _hoisted_48, _toDisplayString(slotProps.item.email_address), 1)
                              ]),
                              _createElementVNode("div", null, [
                                _hoisted_49,
                                _createElementVNode("span", _hoisted_50, _toDisplayString(slotProps.item.contact_no), 1)
                              ]),
                              _createElementVNode("div", null, [
                                _hoisted_51,
                                _createElementVNode("span", _hoisted_52, _toDisplayString(slotProps.item.account_type), 1)
                              ])
                            ]),
                            _: 1
                          }, 8, ["modelValue", "suggestions"])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.v$.selectedProfile.$error && _ctx.submitted)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_53, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.selectedProfile.$errors, (error, index) => {
                            return (_openBlock(), _createElementBlock("span", {
                              id: "p-error",
                              key: index
                            }, [
                              _createElementVNode("small", _hoisted_54, _toDisplayString(error.$message), 1)
                            ]))
                          }), 128))
                        ]))
                      : (
                    (_ctx.v$.selectedProfile.$invalid && _ctx.submitted) ||
                    _ctx.v$.selectedProfile.$pending.$response
                  )
                        ? (_openBlock(), _createElementBlock("small", _hoisted_55, _toDisplayString(_ctx.v$.selectedProfile.required.$message.replace(
                      "Value",
                      "Profile"
                    )), 1))
                        : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_56, [
                    _hoisted_57,
                    (!_ctx.delayedChippedTel)
                      ? (_openBlock(), _createBlock(_component_Chips, {
                          key: 0,
                          modelValue: _ctx.state.chippedTel,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.chippedTel) = $event)),
                          readonly: true,
                          onRemove: _cache[8] || (_cache[8] = ($event: any) => (_ctx.removeProfile($event))),
                          class: "p-chips-input-token"
                        }, null, 8, ["modelValue"]))
                      : _createCommentVNode("", true),
                    (_ctx.delayedChippedTel)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                          _createVNode(_component_AutoComplete, {
                            delay: 1000,
                            minLength: 3,
                            onItemSelect: _cache[9] || (_cache[9] = ($event: any) => (_ctx.saveProfile($event))),
                            scrollHeight: "500px",
                            modelValue: _ctx.state.customerTel,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.customerTel) = $event)),
                            suggestions: _ctx.profilerList,
                            placeholder: "Search Profile from Mobile",
                            onComplete: _cache[11] || (_cache[11] = ($event: any) => (_ctx.searchProfiler($event))),
                            dropdown: false,
                            autoFocus: "",
                            disabled: ""
                          }, {
                            item: _withCtx((slotProps) => [
                              _createElementVNode("div", null, [
                                _hoisted_59,
                                _createElementVNode("b", _hoisted_60, _toDisplayString(slotProps.item.account_title.toUpperCase()), 1)
                              ]),
                              _createElementVNode("div", null, [
                                _hoisted_61,
                                _createElementVNode("span", _hoisted_62, _toDisplayString(slotProps.item.email_address), 1)
                              ]),
                              _createElementVNode("div", null, [
                                _hoisted_63,
                                _createElementVNode("span", _hoisted_64, _toDisplayString(slotProps.item.contact_no), 1)
                              ]),
                              _createElementVNode("div", null, [
                                _hoisted_65,
                                _createElementVNode("span", _hoisted_66, _toDisplayString(slotProps.item.account_type), 1)
                              ])
                            ]),
                            _: 1
                          }, 8, ["modelValue", "suggestions"])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.v$.selectedProfile.$error && _ctx.submitted)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_67, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.selectedProfile.$errors, (error, index) => {
                            return (_openBlock(), _createElementBlock("span", {
                              id: "p-error",
                              key: index
                            }, [
                              _createElementVNode("small", _hoisted_68, _toDisplayString(error.$message), 1)
                            ]))
                          }), 128))
                        ]))
                      : (
                      (_ctx.v$.selectedProfile.$invalid && _ctx.submitted) ||
                      _ctx.v$.selectedProfile.$pending.$response
                    )
                        ? (_openBlock(), _createElementBlock("small", _hoisted_69, _toDisplayString(_ctx.v$.selectedProfile.required.$message.replace(
                        "Value",
                        "Profile"
                      )), 1))
                        : _createCommentVNode("", true)
                  ])
                ]),
                (_ctx.item.type == 'TRN')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                      _createElementVNode("div", _hoisted_71, [
                        _hoisted_72,
                        _createVNode(_component_Dropdown, {
                          modelValue: _ctx.v$.transferStoreID.$model,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.v$.transferStoreID.$model) = $event)),
                          filter: true,
                          options: _ctx.storeList,
                          optionLabel: "name",
                          optionValue: "id",
                          placeholder: "Search Store"
                        }, null, 8, ["modelValue", "options"]),
                        (_ctx.v$.transferStoreID.$error && _ctx.submitted)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_73, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.transferStoreID.$errors, (error, index) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  id: "p-error",
                                  key: index
                                }, [
                                  _createElementVNode("small", _hoisted_74, _toDisplayString(error.$message), 1)
                                ]))
                              }), 128))
                            ]))
                          : (
                    (_ctx.v$.transferStoreID.$invalid && _ctx.submitted) ||
                    _ctx.v$.transferStoreID.$pending.$response
                  )
                            ? (_openBlock(), _createElementBlock("small", _hoisted_75, _toDisplayString(_ctx.v$.transferStoreID.required.$message.replace(
                      "Value",
                      "Transfer Store"
                    )), 1))
                            : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.item.type != 'TRN')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                      _createElementVNode("div", _hoisted_77, [
                        _hoisted_78,
                        _createVNode(_component_InputText, {
                          modelValue: _ctx.item.patientDetails,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.item.patientDetails) = $event)),
                          placeholder: "e.g Patient Jhon Doe",
                          disabled: ""
                        }, null, 8, ["modelValue"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.item.type != 'TRN')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                      _createElementVNode("div", _hoisted_80, [
                        _hoisted_81,
                        _createVNode(_component_InputText, {
                          modelValue: _ctx.item.doctorDetails,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.item.doctorDetails) = $event)),
                          placeholder: "e.g Dr Jhon Doe",
                          disabled: ""
                        }, null, 8, ["modelValue"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_82, [
                  _createElementVNode("div", _hoisted_83, [
                    _hoisted_84,
                    _createVNode(_component_InputText, {
                      modelValue: _ctx.item.description,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.item.description) = $event)),
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_85, [
                  _createElementVNode("div", _hoisted_86, [
                    _hoisted_87,
                    _createVNode(_component_InputText, {
                      modelValue: _ctx.item.remark,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.item.remark) = $event)),
                      id: "remarkField",
                      onKeydown: [
                        _cache[17] || (_cache[17] = _withKeys(_withModifiers(($event: any) => (
                  _ctx.focusNext(
                    'item-unit-' + _ctx.getTopMostItem(),
                    $event,
                    null
                  )
                ), ["prevent"]), ["+"])),
                        _cache[18] || (_cache[18] = _withKeys(_withModifiers(($event: any) => (
                  _ctx.focusNext(
                    'item-unit-' + _ctx.getTopMostItem(),
                    $event,
                    null
                  )
                ), ["prevent"]), ["up"])),
                        _cache[19] || (_cache[19] = _withKeys(_withModifiers(($event: any) => (
                  _ctx.focusNext(
                    'item-unit-' + _ctx.getTopMostItem(),
                    $event,
                    null
                  )
                ), ["prevent"]), ["left"])),
                        _cache[20] || (_cache[20] = _withKeys(_withModifiers(($event: any) => (_ctx.focusNext('nextBtn', $event, null)), ["prevent"]), ["down"]))
                      ],
                      class: _normalizeClass({'is-invalid': _ctx.item.remark == ''})
                    }, null, 8, ["modelValue", "class"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_88, [
                  _createElementVNode("div", _hoisted_89, [
                    _hoisted_90,
                    _createElementVNode("div", _hoisted_91, [
                      (_ctx.taxNames[0] && _ctx.taxNames[0].show)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_92, [
                            _createVNode(_component_Checkbox, {
                              disabled: _ctx.taxNames[0]?.optionalReq == 'Required',
                              modelValue: _ctx.selectedTaxes.tax1,
                              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.selectedTaxes.tax1) = $event)),
                              binary: true
                            }, null, 8, ["disabled", "modelValue"]),
                            _createElementVNode("span", _hoisted_93, _toDisplayString(_ctx.taxNames[0]?.taxName), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.taxNames[1] && _ctx.taxNames[1].show)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_94, [
                            _createVNode(_component_Checkbox, {
                              disabled: _ctx.taxNames[1]?.optionalReq == 'Required',
                              modelValue: _ctx.selectedTaxes.tax2,
                              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.selectedTaxes.tax2) = $event)),
                              binary: true
                            }, null, 8, ["disabled", "modelValue"]),
                            _createElementVNode("span", _hoisted_95, _toDisplayString(_ctx.taxNames[1]?.taxName), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.taxNames[2] && _ctx.taxNames[2].show)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_96, [
                            _createVNode(_component_Checkbox, {
                              disabled: _ctx.taxNames[2]?.optionalReq == 'Required',
                              modelValue: _ctx.selectedTaxes.tax3,
                              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.selectedTaxes.tax3) = $event)),
                              binary: true
                            }, null, 8, ["disabled", "modelValue"]),
                            _createElementVNode("span", _hoisted_97, _toDisplayString(_ctx.taxNames[2]?.taxName), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_98, [
                  _hoisted_99,
                  _createElementVNode("div", _hoisted_100, [
                    _createElementVNode("span", null, [
                      _withDirectives(_createElementVNode("select", {
                        class: "p-inputgroup-addon apply-style-unit",
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.discType) = $event)),
                        disabled: ""
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.discountType, (t) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: t.key,
                            value: t.name
                          }, _toDisplayString(t.name), 9, _hoisted_101))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _ctx.discType]
                      ])
                    ]),
                    _createElementVNode("span", _hoisted_102, [
                      _createVNode(_component_InputText, {
                        modelValue: _ctx.invoiceDiscount,
                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.invoiceDiscount) = $event)),
                        onInput: _ctx.totalDiscAmount,
                        placeholder: "Discount",
                        disabled: ""
                      }, null, 8, ["modelValue", "onInput"])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_103, [
            _createVNode(_component_Button, {
              class: "p-col p-button-success b-style",
              icon: "pi pi-home",
              label: "HOME (Esc)",
              id: "homeBtn",
              onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.redirectHome())),
              onKeydown: [
                _cache[27] || (_cache[27] = _withKeys(_withModifiers(($event: any) => (_ctx.focusNext('nextBtn', $event, null)), ["prevent"]), ["right"])),
                _cache[28] || (_cache[28] = _withKeys(_withModifiers(($event: any) => (_ctx.focusNext('remarkField', $event, null)), ["prevent"]), ["up"]))
              ]
            }),
            _createElementVNode("span", _hoisted_104, [
              _hoisted_105,
              _hoisted_106,
              _createTextVNode(" # " + _toDisplayString(_ctx.savedItemList.length), 1)
            ]),
            _createElementVNode("span", _hoisted_107, [
              _hoisted_108,
              _hoisted_109,
              _createTextVNode(" " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(_ctx.totalGross)), 1)
            ]),
            _createElementVNode("span", _hoisted_110, [
              _hoisted_111,
              _hoisted_112,
              _createTextVNode(" " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(_ctx.totalDiscAmount)), 1)
            ]),
            (_ctx.taxNames[0] && _ctx.taxNames[0].show)
              ? (_openBlock(), _createElementBlock("span", _hoisted_113, [
                  _createTextVNode("Total " + _toDisplayString(_ctx.taxNames[0]?.taxName) + " ", 1),
                  _hoisted_114,
                  _createTextVNode(" " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(_ctx.totalTax1)), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.taxNames[1] && _ctx.taxNames[1].show)
              ? (_openBlock(), _createElementBlock("span", _hoisted_115, [
                  _createTextVNode("Total " + _toDisplayString(_ctx.taxNames[1]?.taxName) + " ", 1),
                  _hoisted_116,
                  _createTextVNode(" " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(_ctx.totalTax2)), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.taxNames[2] && _ctx.taxNames[2].show)
              ? (_openBlock(), _createElementBlock("span", _hoisted_117, [
                  _createTextVNode("Total " + _toDisplayString(_ctx.taxNames[2]?.taxName) + " ", 1),
                  _hoisted_118,
                  _createTextVNode(" " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(_ctx.totalTax3)), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_119, [
              _hoisted_120,
              _hoisted_121,
              _createTextVNode(" " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(_ctx.netTotal)), 1)
            ]),
            _createElementVNode("span", {
              class: "set-bottom-amt p-col",
              hidden: !(_ctx.initialTotalAmount != _ctx.paidAmount)
            }, [
              _createTextVNode("Refund Total (Paid: " + _toDisplayString(_ctx.paidAmount) + ") ", 1),
              _hoisted_123,
              _createTextVNode(" " + _toDisplayString(_ctx.currency) + " " + _toDisplayString((_ctx.paidAmount - (_ctx.initialTotalAmount - _ctx.netTotal) < 0)?0:_ctx.paidAmount - (_ctx.initialTotalAmount - _ctx.netTotal)), 1)
            ], 8, _hoisted_122),
            (_ctx.item.type != 'TRN')
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 3,
                  class: "p-col p-button-warning b-style",
                  icon: "pi pi-arrow-right",
                  label: "NEXT (*)",
                  id: "nextBtn",
                  onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.openPaymentMethod(!_ctx.v$.$invalid))),
                  disabled: _ctx.item.profileID == 0 || _ctx.netTotal <= 0,
                  onKeydown: [
                    _cache[30] || (_cache[30] = _withKeys(_withModifiers(($event: any) => (_ctx.focusNext('remarkField', $event, null)), ["prevent"]), ["up"])),
                    _cache[31] || (_cache[31] = _withKeys(_withModifiers(($event: any) => (_ctx.focusNext('homeBtn', $event, null)), ["prevent"]), ["left"]))
                  ]
                }, null, 8, ["disabled"]))
              : (_openBlock(), _createBlock(_component_Button, {
                  key: 4,
                  class: "p-col p-button-warning b-style",
                  icon: "pi pi-arrow-right",
                  label: "DONE",
                  onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.getProceededPayments([], _ctx.isToggled))),
                  disabled: _ctx.item.profileID == 0 || _ctx.netTotal <= 0
                }, null, 8, ["disabled"]))
          ])
        ]),
        _createVNode(_component_Dialog, {
          visible: _ctx.refundReceiptDialog,
          "onUpdate:visible": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.refundReceiptDialog) = $event)),
          style: { width: '600px' },
          maximizable: true,
          class: "p-fluid",
          modal: true,
          closable: true,
          header: "Search Receipt",
          position: "top"
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_Button, {
              label: "No",
              icon: "pi pi-times",
              class: "p-button-text",
              onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.shiftINE()))
            }),
            _createVNode(_component_Button, {
              label: "Search",
              icon: "pi pi-search",
              class: "p-button-success",
              disabled: _ctx.item.searchReceiptNo == '',
              onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.fetchReceiptNo()))
            }, null, 8, ["disabled"])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_124, [
              _hoisted_125,
              (_ctx.item.type != 'TRN')
                ? (_openBlock(), _createElementBlock("div", _hoisted_126, [
                    _createElementVNode("div", _hoisted_127, [
                      _hoisted_128,
                      _createVNode(_component_InputText, {
                        id: "search_receipt",
                        autoFocus: "",
                        modelValue: _ctx.item.searchReceiptNo,
                        "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.item.searchReceiptNo) = $event)),
                        placeholder: "e.g INE-02502100000000"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["visible"]),
        _createVNode(_component_Dialog, {
          visible: _ctx.removeProfileDialog,
          "onUpdate:visible": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.removeProfileDialog) = $event)),
          style: { width: '450px' },
          header: "Confirm"
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_Button, {
              label: "No",
              icon: "pi pi-times",
              class: "p-button-success",
              onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.removeProfileDialog = false))
            }),
            _createVNode(_component_Button, {
              label: "Yes",
              icon: "pi pi-check",
              class: "p-button-danger",
              onClick: _ctx.changeStatus
            }, null, 8, ["onClick"])
          ]),
          default: _withCtx(() => [
            _hoisted_129
          ]),
          _: 1
        }, 8, ["visible"]),
        _createVNode(_component_Dialog, {
          visible: _ctx.validationPopup,
          "onUpdate:visible": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.validationPopup) = $event)),
          style: { width: '600px' },
          header: "Confirm"
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_Button, {
              label: "Close (Esc)",
              icon: "pi pi-close",
              class: "p-button-danger",
              id: "closePopup",
              onClick: _ctx.closeValidationPopup,
              onKeydown: _withKeys(_withModifiers(_ctx.closeValidationPopup, ["prevent"]), ["enter"])
            }, null, 8, ["onClick", "onKeydown"])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_130, [
              _hoisted_131,
              _createElementVNode("span", null, _toDisplayString(_ctx.validationPopupMessage), 1)
            ])
          ]),
          _: 1
        }, 8, ["visible"])
      ]),
      _: 1
    }, 8, ["fullscreen", "teleport", "page-only"]),
    _createVNode(_component_PaymentScreen, {
      receiptDetail: {
      dialogStatus: _ctx.paymentDialog,
      itemSource: _ctx.item.type,
      restriction: 'No',
      paymentOptionType: 'Cashier',
      cashPayment:this.cashPaymentOption,
      cardPayment:this.cardPaymentOption,
      bankTransferPayment:this.bankTransferPaymentOption,
      hideKeyPad:true,
      dialogTitle: 'Sales Refund',
      receivedTxt: 'Amount',
      customerID: this.item.profileID,
      customerName: this.state.selectedProfile,
      closeConfirmation: true,
    },
      onClosePaymentScreenEvent: _ctx.closePaymentScreen,
      onGetProceededPaymentsEvent: _ctx.getProceededPayments
    }, null, 8, ["receiptDetail", "onClosePaymentScreenEvent", "onGetProceededPaymentsEvent"])
  ], 64))
}